import React, { useEffect, useState } from 'react';
import './PaginaInicio.css';
import './HomeworkPage.css';
import Cabecera from '../Others/Cabecera';
import PiePagina from '../Others/PiePagina';
import BarraSuperior from '../Others/BarraSuperior';
import BarraInferior from '../Others/BarraInferior';
import axios from 'axios';
import { useData } from './DataContext';
import { routeGetDiagnosticEvaluation } from './constants';
import BarraInferiorPersonalizadaStudent from './BarraInferiorPersonalizadaStudent';

const barra_inferior = <BarraInferior contenido={<BarraInferiorPersonalizadaStudent />} />;

const StudentForm = () => {
  const { dataClase } = useData();
  const [formUrl, setFormUrl] = useState('');
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState('');

  const barra_superior = (
    <BarraSuperior
      texto_cabecera={dataClase?.nombre_clase || ''}
      redireccion="pagina-inicio"
      profile_redireccion="profile-page"
    />
  );

  useEffect(() => {
    const callForm = async () => {
      if (!dataClase?.id_clase) {
        setError('No fue posible identificar la clase seleccionada.');
        setCargando(false);
        return;
      }

      try {
        const response = await axios.get(routeGetDiagnosticEvaluation, {
          params: { id_evaluaciones: dataClase.id_clase },
        });
        setFormUrl(response.data?.evaluacion_diagnostica || '');
      } catch (requestError) {
        console.error('Error al obtener la evaluación diagnóstica:', requestError);
        setError('No fue posible consultar la evaluación diagnóstica.');
      } finally {
        setCargando(false);
      }
    };

    callForm();
  }, [dataClase?.id_clase]);

  return (
    <div className="contenedor-pagina">
      <Cabecera contenidosuperior={barra_superior} contenidoInferior={barra_inferior} />
      <div className="homework-container">
        <div className="h-title"><h1>Evaluación Diagnóstica</h1></div>
        <div className="h-holder">
          <div className="h-content">
            {cargando && <p>Cargando evaluación...</p>}
            {!cargando && error && <p>{error}</p>}
            {!cargando && !error && !formUrl && (
              <p>No hay una evaluación diagnóstica configurada para esta clase.</p>
            )}
            {!cargando && !error && formUrl && (
              <iframe
                src={formUrl}
                width="640"
                height="800"
                frameBorder="0"
                marginHeight="0"
                marginWidth="0"
                title="Evaluación diagnóstica"
              >
                Cargando...
              </iframe>
            )}
          </div>
        </div>
      </div>
      <PiePagina imagenSrc={require('../Assets/piepagina.jpg')} />
      <footer>Grupo Derecho & Progreso &copy; 2024</footer>
    </div>
  );
};

export default StudentForm;
